jQuery(function($){
	$('.co-child-menu-mobile-expand').on('click', function(){
		let wasExpanded = $(this).hasClass('expanded');

		if(wasExpanded) {
			$(this).removeClass('expanded').closest('.co-section').find('.co-child-menu').removeClass('expanded');
		} else {
			$(this).addClass('expanded').closest('.co-section').find('.co-child-menu').addClass('expanded');
		}
	});

	$('.event-ticket-modal-trigger').on('click', function(e){
		e.preventDefault();

		const modalId = $(this).attr('href');
		if($(modalId).hasClass('not-loaded')) {
			const modalContent = $(modalId).attr('data-content');
			const modalContentDiv = $(modalId).find('.event-ticket-modal-body').html(atob(modalContent));

		}
		$(modalId).addClass('showing');
		console.log(modalId);
	});

	$('.event-ticket-modal-bg').on('click', function(){
		const modal = $(this).closest('.event-ticket-modal');
		closeEventTicketModal(modal);
	});

	$('.event-ticket-modal-close').on('click', function(){
		const modal = $(this).closest('.event-ticket-modal');
		closeEventTicketModal(modal);
	});

	function closeEventTicketModal(modalEl) {
		modalEl.removeClass('showing');
	}
});